import React from "react";
import "../Button.css";
function Button(props) {
  return (
    <div>
      <button class="pulse" title={props.name}>
        <img src={props.logo} />{" "}
        <span className="btn-name"> {props.name} </span>
      </button>
    </div>
  );
}

export default Button;
